import React from "react"
import { makeStyles } from "@material-ui/styles"
import Typography from "@material-ui/core/Typography"
import { RichDescription, RichTitle } from ".."

const useStyles = makeStyles(theme => {
  return {
    root: props => ({
      background: props.color ? props.color : theme.palette.green.support,
      display: "flex",
      flexDirection: "column-reverse",
      height: 640,
      position: "relative",
      zIndex: 0,
      [theme.breakpoints.down("md")]: {
        height: "50vh",
      },
      [theme.breakpoints.down("sm")]: {
        height: "80vh",
      },
    }),
    copy: props => ({
      alignItems: "flex-start",
      display: "flex",
      flexDirection: "column",
      height: "100%",
      justifyContent: "center",
      margin: props.isProductLine
        ? theme.spacing(0, 2, 0, 8)
        : theme.spacing(0, 8),
      padding: theme.spacing(4, 1),
      textAlign: "left",
      [theme.breakpoints.down("md")]: {
        alignItems: "center",
        margin: 0,
      },
    }),
    copyText: props => ({
      marginBottom: 32,
      lineHeight: props.isProductLine ? "32px" : "unset",
      [theme.breakpoints.down("md")]: {
        textAlign: "center",
      },
    }),
    staticCopyText: {
      marginBottom: 32,
      [theme.breakpoints.down("md")]: {
        textAlign: "center",
        padding: theme.spacing(0, 4),
      },
      [theme.breakpoints.between("md", "lg")]: {
        fontSize: theme.spacing(2),
      },
    },
    titleText: props => ({
      marginBottom: 32,
      [theme.breakpoints.down("md")]: {
        textAlign: "center",
      },
    }),
    staticTitleText: props => ({
      marginBottom: 32,
      [theme.breakpoints.down("md")]: {
        textAlign: "center",
      },
      [theme.breakpoints.between("md", "lg")]: {
        fontSize: theme.spacing(4),
        marginTop: theme.spacing(3),
      },
    }),
  }
})

export default props => {
  const classes = useStyles(props)
  return (
    <div className={classes.root}>
      <div className={classes.copy}>
        {props.static && (
          <Typography
            className={
              props.static ? classes.staticTitleText : classes.titleText
            }
          >
            {props.titleText && <RichTitle titleText={props.titleText} />}
          </Typography>
        )}
        <Typography
          className={props.static ? classes.staticCopyText : classes.copyText}
        >
          {props.copyText && <RichDescription copyText={props.copyText} />}
        </Typography>
      </div>
    </div>
  )
}
